export enum Payment {
  CREATE_PAYMENT_REQUEST = '@payment/CREATE_PAYMENT_REQUEST',
  CREATE_PAYMENT_SUCCESS = '@payment/CREATE_PAYMENT_SUCCESS',
  CREATE_PAYMENT_FAIL = '@payment/CREATE_PAYMENT_FAIL',

  GET_PAYMENT_REQUEST = '@payment/GET_PAYMENT_REQUEST',
  GET_PAYMENT_SUCCESS = '@payment/GET_PAYMENT_SUCCESS',
  GET_PAYMENT_FAIL = '@payment/GET_PAYMENT_FAIL',

  UPLOAD_PAYMENT_REQUEST = '@payment/UPLOAD_PAYMENT_REQUEST',
  UPLOAD_PAYMENT_SUCCESS = '@payment/UPLOAD_PAYMENT_SUCCESS',
  UPLOAD_PAYMENT_FAIL = '@payment/UPLOAD_PAYMENT_FAIL',

  GET_PAYEES_REQUEST = '@payment/GET_PAYEES_REQUEST',
  GET_PAYEES_SUCCESS = '@payment/GET_PAYEES_SUCCESS',
  GET_PAYEES_FAIL = '@payment/GET_PAYEES_FAIL',
}
